import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-hu",
  "use": "icon-flag-hu-usage",
  "viewBox": "0 0 1544 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1544 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-hu\"><defs><style type=\"text/css\"></style></defs><path d=\"M10.039216 1017.72549h1517.17647V8.784314H10.039216v1008.941176z m1520.941176 2.509804V1016.470588v3.764706zM3.764706 1024V1.254902h1529.72549v1021.490196H3.764706z\" fill=\"#353636\" p-id=\"797\" /><path d=\"M7.529412 681.411765H1530.980392v338.823529H7.529412z\" fill=\"#009958\" p-id=\"798\" /><path d=\"M7.529412 343.843137H1530.980392v338.82353H7.529412z\" fill=\"#FFFFFF\" p-id=\"799\" /><path d=\"M7.529412 5.019608H1530.980392v338.823529H7.529412z\" fill=\"#D04542\" p-id=\"800\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-hu.svg
// module id = 5tny
// module chunks = 24